"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var CartNudge = function (props) { return (React.createElement("div", { className: "cart-nudge cart-nudge--trending-up" },
    React.createElement("div", { className: "cart-nudge__icon" }),
    React.createElement("div", { className: "cart-nudge__inner" },
        React.createElement("p", { className: "cart-nudge__title" }, I18n.t('discovery.cartNudge.predictedToSellSoon')),
        React.createElement("p", { className: "cart-nudge__subtitle" }, I18n.t('discovery.cartNudge.peopleHaveInCarts', { count: props.otherBuyersWithListingInCartCount }))))); };
exports.default = CartNudge;
//# sourceMappingURL=cart_nudge.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/cart_nudge/cart_nudge.js
// module id = S14A
// module chunks = 20 21